import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Container from "@mui/material/Container";
import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import logo from "assets/images/Spechs_logo/logo_no_text_transparent.png";

function ScrollNavbar({ title }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <MKBox
      component="nav"
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        background: scrolled ? "rgba(255,255,255,0.97)" : "transparent",
        backdropFilter: scrolled ? "blur(8px)" : "none",
        borderBottom: scrolled ? "1px solid #e9ecef" : "1px solid transparent",
        boxShadow: scrolled ? "0 1px 8px rgba(0,0,0,0.06)" : "none",
        transition: "background 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease",
      }}
    >
      <Container>
        <MKBox display="flex" alignItems="center" justifyContent="space-between" py={1.5}>
          {/* Left: logo + title */}
          <MKBox display="flex" alignItems="center" gap={1}>
            <MKBox
              component="img"
              src={logo}
              alt="Spechs"
              sx={{
                height: 32,
                mr: 1,
                display: "block",
                filter: scrolled ? "none" : "drop-shadow(0 0 1px rgba(255,255,255))",
                transition: "filter 0.3s ease",
              }}
            />
            <MKTypography
              component="span"
              variant="h5"
              fontWeight="bold"
              sx={{ display: { xs: "none", sm: "flex" }, alignItems: "center" }}
            >
              <span
                style={{
                  color: scrolled ? "#32373c" : "white",
                  textShadow: scrolled ? "none" : "0 1px 2px rgba(0,0,0,0.6)",
                  transition: "color 0.3s ease",
                }}
              >
                Spechs{" "}
              </span>
              <span
                style={{
                  color: scrolled ? "rgba(50,55,60,0.45)" : "rgba(255,255,255,0.5)",
                  transition: "color 0.3s ease",
                }}
              >
                {title}
              </span>
            </MKTypography>
          </MKBox>

          {/* Right: home link */}
          <Link
            to="/"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              textDecoration: "none",
              flexShrink: 0,
              transition: "opacity 0.2s ease",
            }}
          >
            <Icon
              sx={{
                fontSize: "18px !important",
                color: scrolled ? "#32373c !important" : "white !important",
                transition: "color 0.3s ease",
              }}
            >
              home
            </Icon>
            <MKBox component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
              <span
                style={{
                  color: scrolled ? "#32373c" : "white",
                  whiteSpace: "nowrap",
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  letterSpacing: "0.02em",
                  textShadow: scrolled ? "none" : "0 1px 2px rgba(0,0,0,0.6)",
                  transition: "color 0.3s ease",
                }}
              >
                Spechs Home
              </span>
            </MKBox>
          </Link>
        </MKBox>
      </Container>
    </MKBox>
  );
}

ScrollNavbar.propTypes = {
  title: PropTypes.string.isRequired,
};

export default ScrollNavbar;
